
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import BrochureHero from './components/BrochureHero';
import ProjectsOverview from './components/ProjectsOverview';
import UpstreamProjects from './components/UpstreamProjects';
import ProductionServices from './components/ProductionServices';
import MidstreamDownstream from './components/MidstreamDownstream';
import ADNOCServices from './components/ADNOCServices';

const Brochure = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <BrochureHero />
      <ProjectsOverview />
      <UpstreamProjects />
      <ProductionServices />
      <MidstreamDownstream />
      <ADNOCServices />
      <Footer />
    </div>
  );
};

export default Brochure;
